import React, { useRef, useState, useCallback } from "react";

const ResizableBox = ({ children }) => {
  const boxRef = useRef(null);
  const [height, setHeight] = useState(180);
  const [isResizing, setIsResizing] = useState(false);
  const isResizingRef = useRef(false);

  const handleMouseMove = useCallback((e) => {
    if (!isResizingRef.current) return;

    const boxTop = boxRef.current.getBoundingClientRect().top;
    const newHeight = e.clientY - boxTop;

    if (newHeight >= 100 && newHeight <= 500) {
      setHeight(newHeight);
    }
  }, []);

  const stopResizing = useCallback(() => {
    isResizingRef.current = false;
    setIsResizing(false);
    document.body.style.userSelect = "auto";
    document.body.style.cursor = "auto";
    
    // Remove event listeners when resizing stops
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", stopResizing);
  }, [handleMouseMove]);

  const startResizing = useCallback((e) => {
    e.preventDefault();
    isResizingRef.current = true;
    setIsResizing(true);
    document.body.style.userSelect = "none";
    document.body.style.cursor = "row-resize";
    
    // Add event listeners only when resizing starts
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", stopResizing);
  }, [handleMouseMove, stopResizing]);

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      // Clean up any remaining listeners if component unmounts during resize
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", stopResizing);
      // Reset cursor and selection
      document.body.style.userSelect = "auto";
      document.body.style.cursor = "auto";
    };
  }, [handleMouseMove, stopResizing]);

  return (
    <div
      ref={boxRef}
      className="resizable-box"
      style={{ height: `${height}px` }}
      title="Drag the bottom edge to resize"
    >
      {children}
      <div 
        className="resizer-handle" 
        onMouseDown={startResizing}
        title="Drag to resize"
        role="separator"
        aria-orientation="horizontal"
        aria-label="Resize handle"
      />
    </div>
  );
};
export default ResizableBox;
